import * as React from 'react';
import NetworkingType from '../../models/Networking';
import './style.scss';
import SocialNetworkLinkLogo from '../SocialNetworkLinkLogo';

interface Props {
  networking: NetworkingType[];
  isLegacy?: boolean;
}

const Networking: React.SFC<Props> = ({ networking, isLegacy = true }) => {
  const classPrefix = isLegacy ? 'networking-legacy' : 'networking';

  return (
    <div className={classPrefix}>
      {networking.map((item: NetworkingType, index: number) => {
        return (
          <SocialNetworkLinkLogo
            key={`networking-${item.href}-${index}`}
            Icon={item.icon}
            href={item.href}
          />
        );
      })}
    </div>
  );
};

export default Networking;
